// Helper functions for generating Impact by Residential Status chart data

import { getFilteredReportData } from '../helpers/filterHelpers'
import { residentialStatuses, residentialStatusesLabels } from './fields'
import { ETHNICITY_IMPACT } from '../fields'

// Generate chart data for residential status
const generateResidentialStatusChartData = ethnicityData => {
  if (ethnicityData) {
    const labels = Object.values(residentialStatusesLabels)
    const data = [
      ethnicityData[residentialStatuses.local] || 0,
      ethnicityData[residentialStatuses.non_local] || 0,
      ethnicityData[residentialStatuses.international] || 0,
      ethnicityData[residentialStatuses.unknown] || 0
    ]

    return {
      labels: labels,
      datasets: [
        {
          label: 'Impact by Residential Status',
          data: data,
          backgroundColor: '#14332D',
          borderRadius: 4,
          maxBarThickness: 55
        }
      ]
    }
  } else {
    return {
      labels: [],
      datasets: []
    }
  }
}

// Main function to generate chart data
export const generateResidentialStatusData = ({ selectedRegion, selectedStakeholder, report }) => {
  const ethnicityData = getFilteredReportData({
    report,
    selectedRegion,
    selectedStakeholder,
    fieldName: ETHNICITY_IMPACT
  })
  return generateResidentialStatusChartData(ethnicityData)
}
